import { notification } from 'antd'
import { action, makeObservable, observable } from 'mobx'

import api from 'services/api'
import { IRootStore } from 'store/types'
import { formateTime } from 'utils/formatting/formateTime/formateTime'
import { PromoSiteContactRequest } from 'types/types'

import { searchEngineV2Api } from './api'
import { INITIAL_MESSAGE } from './data'
import { DialogBranchBaseOption, DialogBranches, MessagesType } from './types'

import chatIcon from 'assets/img/searchEngine/chat__icon.svg'

const RegularChatBranch = {
  value: DialogBranches.regularChat,
  label: 'Чат с помощником',
  icon: chatIcon,
}

export const branchesType: DialogBranchBaseOption[] = [RegularChatBranch]

export class SearchEngineUiStore {
  @observable loading: boolean = false
  @observable sending: boolean = false
  @observable problemReportModalOpen: boolean = false
  @observable isOpen: boolean = false
  @observable typeFinished: boolean = false
  @observable message: string = ''
  @observable messages: MessagesType[] = []
  @observable dialogBranch: DialogBranchBaseOption = RegularChatBranch
  @observable isResolveVisible: boolean = false
  @observable isRejectVisible: boolean = false

  constructor(private readonly rootStore: IRootStore) {
    makeObservable(this)
    this.messages = [{ text: INITIAL_MESSAGE, me: false, answerTime: this.getCurrentTime() }]
  }

  @action
  setDialogBranch = (value: DialogBranchBaseOption) => {
    this.dialogBranch = value
  }

  @action setIsResolveVisible = (value: boolean) => {
    this.isResolveVisible = value
  }

  @action setIsRejectVisible = (value: boolean) => {
    this.isRejectVisible = value
  }

  @action
  setLoading = (value: boolean) => {
    this.loading = value
  }

  @action
  setProblemReportModalOpen = (value: boolean) => {
    this.problemReportModalOpen = value
  }

  @action
  toggleIsOpen = (value: boolean) => {
    this.isOpen = value
    this.setDialogBranch(RegularChatBranch)
  }

  @action
  setMessage = (value: string) => {
    this.message = value
  }

  @action
  sendMessage = () => {
    if (this.dialogBranch.value === DialogBranches.regularChat) {
      this.sendTextMessage()
    }
  }

  @action
  setSending = (value: boolean) => {
    this.sending = value
  }

  @action
  getCurrentTime = () => {
    return formateTime(new Date())
  }

  @action
  extractTimeFromServerResponse = (serverTime: string): string => {
    const timeMatch = serverTime.match(/\d{2}:\d{2}:\d{2}/)

    if (timeMatch) {
      const [hours, minutes] = timeMatch[0].split(':')
      return `${hours}:${minutes}`
    }

    return '00:00'
  }

  @action
  sendTextMessage = async () => {
    if (this.message === '') {
      return
    }

    this.messages.push({
      text: this.message,
      me: true,
      answerTime: this.getCurrentTime(),
    })
    this.setSending(true)
    try {
      const data = await searchEngineV2Api.sendClientMessage(this.message)
      if (data && data.answerTime) {
        this.messages.push({
          text: data.answer as string,
          me: false,
          answerTime: this.extractTimeFromServerResponse(data.answerTime),
        })
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка при отправке сообщения.',
        description: (error as Error).message,
      })
    } finally {
      this.setMessage('')
      this.setSending(false)
    }
  }

  @action
  sendReviewMessage = async (data: PromoSiteContactRequest): Promise<void> => {
    try {
      await api.requests.addReview(data)
      this.setIsResolveVisible(true)
    } catch (error) {
      this.setIsRejectVisible(true)
      notification.error({
        message: 'Ошибка при отправке обращения.',
        description: (error as Error).message,
      })
    }
  }
}
